module.exports = "<div class=\"mouse-action-section\">\n        <div\n                class=\"selection-section\"\n                v-show=\"selection.startSelection\"\n                :style=\"getSelectionStyle();\"\n        ></div>\n    </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/selection.vue
 ** module id = 58
 ** module chunks = 0
 **/